import { Loader2 } from 'lucide-react';
import './ButtonSpinner.css';

export type ButtonSpinnerProps = {
    size?: 'sm' | 'md';
    className?: string;
};

const SIZE_PX: Record<NonNullable<ButtonSpinnerProps['size']>, number> = {
    sm: 14,
    md: 16,
};

/**
 * ButtonSpinner — Tier-3 inline pending indicator.
 *
 * Drop inside a <button> next to the label while a mutation is in
 * flight. Prefer wrapping the `pending` flag in `useDeferredLoader` so
 * fast mutations (< 250 ms) never flash the spinner.
 */
export function ButtonSpinner({ size = 'sm', className = '' }: ButtonSpinnerProps) {
    return (
        <Loader2
            size={SIZE_PX[size]}
            className={`ui-button-spinner ${className}`}
            aria-hidden="true"
        />
    );
}
